import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../../../shared/services/app/profile.service';
import { ROUTE_AUTH, ROUTE_LOGIN } from '../../../shared/consts/routes.const';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private profile = inject(ProfileService);
  private router = inject(Router);

  ngOnInit() {
    this.profile.logout();
    this.router.navigate([`/${ROUTE_AUTH}/${ROUTE_LOGIN}`]);
  }
}
